<script>
import Layout from '@layouts/main'
import ArtistBlock from '@components/artist/artist-block'

export default {
    page() {
        const title = 'Your Artists'
        const description = 'Your Artists'
        return {
            title,
            meta: [
                { name: 'title', vmid: 'title', content: title },
                { name: 'description', vmid: 'description', content: description },

                { property: 'og:title', vmid: 'og:title', content: title },
                { property: 'og:description', vmid: 'og:description', content: description },

                { property: 'twitter:title', vmid: 'twitter:title', content: title },
                { property: 'twitter:description', vmid: 'twitter:description', content: description },
            ],
        }
    },
    components: { Layout, ArtistBlock },
    data() {
        return {
            favPopulatedList: Array.from(Array(6), (e, i) => ({
                artists: {
                    id: Number.MAX_SAFE_INTEGER - i,
                },
            })),
            shouldTransition: false,
            maxArtists: 30,
            increaseArtists: 15,
            shouldLoadMore: false,
        }
    },
    computed: {
        favList() {
            return this.$store.state.favorites.artistsList
        },
        artistsList() {
            return this.favPopulatedList.map(el => el.artists)
        },
        scroll() {
            return this.$store.state.appearance.scroll
        },
        scrollChild() {
            return this.$store.state.appearance.scrollChild
        },
    },
    watch: {
        favList: {
            handler() {
                this.$dataLayer.favArtists
                    .get(this.maxArtists)
                    .then(({ body }) => {
                        this.favPopulatedList = body
                        this.shouldLoadMore = true
                    })
                    .then(() => {
                        this.shouldTransition = true
                    })
            },
            immediate: true,
        },
        scroll() {
            let bottomOfWindow =
                this.scroll + window.innerHeight >=
                this.$store.state.appearance.scrollChild.offsetHeight - window.innerHeight / 3

            if (bottomOfWindow && this.shouldLoadMore) {
                this.shouldLoadMore = false
                setTimeout(() => {
                    this.shouldLoadMore = true
                }, 200)
                this.loadMoreArtists()
            }
        },
    },
    methods: {
        loadMoreArtists() {
            this.maxArtists += this.increaseArtists
            this.$dataLayer.favArtists.get(this.maxArtists).then(({ body }) => {
                this.favPopulatedList = body
                this.shouldLoadMore = true
            })
        },
    },
}
</script>

<template>
    <!-- <BaseContent
            class="ppage"
            title="Mixes"
        > -->
    <Layout>
        <BaseContent title="Your Artists">
            <BaseSection padded>
                <ArtistBlock
                    v-if="artistsList.length"
                    :artists="artistsList"
                    :should-transition="shouldTransition"
                    wrapping
                    wrapping-mobile
                    is-indexed-list
                />
                <BaseEmptyList
                    v-else
                    :error="{
                        title: `You are not following any artists.`,
                        paragraph: 'Following artists helps us recommend similar artists.',
                    }"
                />
            </BaseSection>
        </BaseContent>
    </Layout>
</template>

<style lang="scss" scoped>
@import '@design';
</style>
